'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Main = require('./Main.scss');

var _Main2 = _interopRequireDefault(_Main);

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _reactRedux = require('react-redux');

var _trip = require('redux/modules/trip');

var tripDetailAction = _interopRequireWildcard(_trip);

var _payment = require('redux/modules/payment');

var _Reviews = require('components/Review/Reviews');

var _Reviews2 = _interopRequireDefault(_Reviews);

var _CustomizeBox = require('components/Customize/CustomizeBox');

var _CustomizeBox2 = _interopRequireDefault(_CustomizeBox);

var _RequestBook = require('components/TripDetail/RequestBook');

var _RequestBook2 = _interopRequireDefault(_RequestBook);

var _Modal = require('components/General/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Chat = require('components/TripDetail/Chat');

var _Chat2 = _interopRequireDefault(_Chat);

var _Breadcrumbs = require('components/Breadcrumbs/Breadcrumbs');

var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);

var _WeChat = require('components/Popup/WeChat');

var _WeChat2 = _interopRequireDefault(_WeChat);

var _Banner = require('components/TripDetail/Banner');

var _Banner2 = _interopRequireDefault(_Banner);

var _PeerReviewHeader = require('components/TripDetail/PeerReviewHeader');

var _PeerReviewHeader2 = _interopRequireDefault(_PeerReviewHeader);

var _Introduction = require('components/TripDetail/Introduction');

var _Introduction2 = _interopRequireDefault(_Introduction);

var _Itinerary = require('components/TripDetail/Itinerary');

var _Itinerary2 = _interopRequireDefault(_Itinerary);

var _Detail = require('components/TripDetail/Detail');

var _Detail2 = _interopRequireDefault(_Detail);

var _PriceCondition = require('components/TripDetail/PriceCondition');

var _PriceCondition2 = _interopRequireDefault(_PriceCondition);

var _Faq = require('components/TripDetail/Faq');

var _Faq2 = _interopRequireDefault(_Faq);

var _MeetingPoint = require('components/TripDetail/MeetingPoint');

var _MeetingPoint2 = _interopRequireDefault(_MeetingPoint);

var _Images = require('components/TripDetail/Images');

var _Images2 = _interopRequireDefault(_Images);

var _SimilarTrips = require('components/TripDetail/SimilarTrips');

var _SimilarTrips2 = _interopRequireDefault(_SimilarTrips);

var _PeerReviewForm = require('components/TripDetail/PeerReviewForm');

var _PeerReviewForm2 = _interopRequireDefault(_PeerReviewForm);

var _MobileAction = require('components/TripDetail/MobileAction');

var _MobileAction2 = _interopRequireDefault(_MobileAction);

var _MobileTab = require('components/TripDetail/MobileTab');

var _MobileTab2 = _interopRequireDefault(_MobileTab);

var _PriceBar = require('components/TripDetail/PriceBar');

var _PriceBar2 = _interopRequireDefault(_PriceBar);

var _customize = require('redux/modules/customize');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Main: {
    displayName: 'Main'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Main.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Element = _reactScroll2.default.Element;
// import MobileContent from 'components/TripDetail/MobileContent';

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var Main = _wrapComponent('Main')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    trip: state.trip.data,
    sessionData: state.session.data,
    isOpenChat: state.trip.openChat,
    user: state.session.user,
    locale: state.language.locale,
    tab: state.trip.mobileTab,
    isOpenPeerReview: state.trip.isOpenPeerReview,
    //
    weChatEveryLink: state.info.siteConfigs.weChatEveryLink
  };
}, (0, _extends3.default)({}, tripDetailAction, { logCustomizeTrip: _customize.logCustomizeTrip, requestBooking: _payment.requestBooking })), _dec2 = (0, _reactCssModules2.default)(_Main2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props));

    _this.getQuantity = function () {
      return _this.props.sessionData.quantity > _this.props.trip.max_travelers ? _this.props.trip.max_travelers : _this.props.sessionData.quantity;
    };

    _this.openChat = function () {
      _this.props.openChat();
      _this.props.requestBooking('message', 'desktop', _this.props.trip._id, null, _this.getQuantity());
    };

    _this.closeChat = function () {
      _this.props.openChat(false);
    };

    _this.handleScroll = _this.handleScroll.bind(_this);

    if (!(typeof _this.handleScroll === 'function')) {
      throw new TypeError('Value of "this.handleScroll" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.handleScroll));
    }

    _this.desktopScroll = _this.desktopScroll.bind(_this);

    if (!(typeof _this.desktopScroll === 'function')) {
      throw new TypeError('Value of "this.desktopScroll" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.desktopScroll));
    }

    _this.mobileScroll = _this.mobileScroll.bind(_this);

    if (!(typeof _this.mobileScroll === 'function')) {
      throw new TypeError('Value of "this.mobileScroll" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.mobileScroll));
    }

    _this.onClosePeerReview = _this.onClosePeerReview.bind(_this);

    if (!(typeof _this.onClosePeerReview === 'function')) {
      throw new TypeError('Value of "this.onClosePeerReview" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.onClosePeerReview));
    }

    _this.state = {
      stickyStyle: { 'alignSelf': 'flex-start' },
      mounted: false,
      tabStyle: { alignSelf: 'flex-start' },
      // mounted: false,
      // lastScrollTop: 0,
      showPrice: false
    };
    _this.lastScrollTop = 0;
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
      this.setState({ mounted: true }); // eslint-disable-line
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'onClosePeerReview',
    value: function onClosePeerReview() {
      this.props.openPeerReview(false);
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      this.desktopScroll();
      this.mobileScroll();
    }
  }, {
    key: 'desktopScroll',
    value: function desktopScroll() {
      var offset = 66;
      var top = this.refs.stickyContainer.getBoundingClientRect().top;
      var elmHeight = this.refs.stickyElement.offsetHeight;
      var contHeight = this.refs.stickyContainer.offsetHeight;
      if (top >= offset) {
        if (this.state.stickyState === 'top') return;
        this.setState({
          stickyState: 'top',
          stickyStyle: { 'alignSelf': 'flex-start' }
        });
      } else if (Math.abs(top) + elmHeight + offset >= contHeight) {
        // Care case container is too short
        if (this.state.stickyState === 'bottom') return;
        this.setState({
          stickyState: 'bottom',
          stickyStyle: { 'alignSelf': 'flex-end' }
        });
      } else if (this.state.stickyState !== 'fixed') {
        if (this.state.stickyState === 'fixed') return;
        this.setState({
          stickyState: 'fixed',
          stickyStyle: { 'position': 'fixed', 'width': '300px', 'top': offset + 'px' }
        });
      }
    }
  }, {
    key: 'mobileScroll',
    value: function mobileScroll() {
      var offset = 55;
      var bannerH = 240;
      // const { lastScrollTop } = this.state;
      var lastScrollTop = this.lastScrollTop;
      var tabType = this.state.tabType;

      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if (st > lastScrollTop) {
        // downscroll code
        if (st > bannerH && tabType !== 'hiding') {
          this.setState({
            tabStyle: {
              width: '100%',
              background: 'white',
              position: 'fixed',
              top: '-30px',
              transition: 'top 0.4s ease-out',
              zIndex: '100'
            },
            showPrice: true,
            tabType: 'hiding'
          });
        }
      } else {
        // upscroll code
        if (st > bannerH && tabType !== 'showing') {
          // eslint-disable-line
          this.setState({
            tabStyle: {
              position: 'fixed',
              top: offset + 'px',
              transition: 'top 0.4s ease-in',
              width: '100%',
              background: 'white',
              zIndex: '100'
            },
            showPrice: true,
            tabType: 'showing'
          });
        } else if (st <= bannerH && tabType !== 'default') {
          this.setState({
            tabStyle: {
              alignSelf: 'flex-start'
            },
            showPrice: false,
            tabType: 'default'
          });
        }
      }
      // this.setState({ lastScrollTop: st });
      this.lastScrollTop = st;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          trip = _props.trip,
          isOpenChat = _props.isOpenChat,
          locale = _props.locale,
          peerReview = _props.peerReview,
          isOpenPeerReview = _props.isOpenPeerReview,
          user = _props.user,
          weChatEveryLink = _props.weChatEveryLink;

      return _react3.default.createElement(
        'div',
        { styleName: 'desktop-show' },
        !peerReview && _react3.default.createElement(_Banner2.default, { trip: trip }),
        _react3.default.createElement(
          'div',
          { styleName: 'outer' },
          !peerReview && _react3.default.createElement(_Breadcrumbs2.default, {
            customStyle: { padding: '20px 2.5% 0' },
            type: 'TripDetail',
            trip: trip
          }),
          _react3.default.createElement(
            'div',
            { styleName: 'mobile-only' },
            _react3.default.createElement(
              'div',
              { ref: 'mobileTab', style: this.state.tabStyle },
              this.state.showPrice && !peerReview && _react3.default.createElement(_PriceBar2.default, { trip: trip }),
              !peerReview && _react3.default.createElement(_MobileTab2.default, null)
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: peerReview ? 'inner-peer' : 'inner' },
            _react3.default.createElement(
              'div',
              { styleName: 'big-column' },
              peerReview && _react3.default.createElement(_PeerReviewHeader2.default, null),
              _react3.default.createElement(Element, { name: 'overview' }),
              _react3.default.createElement(_Introduction2.default, { trip: trip, peerReview: peerReview }),
              !peerReview && _react3.default.createElement(_Faq2.default, { trip: trip }),
              _react3.default.createElement(_Images2.default, { trip: trip }),
              _react3.default.createElement(Element, { name: 'detail' }),
              trip.is_per_day !== true && _react3.default.createElement(_Itinerary2.default, { trip: trip, locale: locale }),
              !peerReview && _react3.default.createElement(_Detail2.default, { trip: trip }),
              !peerReview && _react3.default.createElement(_PriceCondition2.default, { trip: trip }),
              !peerReview && _react3.default.createElement(_MeetingPoint2.default, { trip: trip })
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'inner-calendar', ref: 'stickyContainer', id: 'thisContainer' },
              _react3.default.createElement(
                'div',
                { styleName: 'calendar-slider', ref: 'stickyElement', style: this.state.stickyStyle },
                _react3.default.createElement(
                  'div',
                  { styleName: 'slider-item-container' },
                  function () {
                    if (peerReview) {
                      return _react3.default.createElement(_PeerReviewForm2.default, null);
                    }
                    if (weChatEveryLink) {
                      return _react3.default.createElement(_WeChat2.default, { isShowPrice: true, trip: trip });
                    }
                    return _react3.default.createElement(_RequestBook2.default, { onOpenChat: _this2.openChat, trip: trip });
                  }()
                )
              )
            )
          )
        ),
        _react3.default.createElement(Element, { name: 'review' }),
        _react3.default.createElement(
          'div',
          null,
          !peerReview && !weChatEveryLink && _react3.default.createElement(
            'div',
            { ref: 'reviewsContainer', styleName: 'inner-reviews' },
            _react3.default.createElement(_Reviews2.default, { reviews: trip.reviews, lxName: trip.user_id.name.first, woReview: trip.travelers_without_review })
          ),
          !trip.is_similar_hidden && trip.similarTrips && trip.similarTrips.length > 0 && !peerReview && !weChatEveryLink && _react3.default.createElement(
            'div',
            { styleName: 'inner-similar' },
            _react3.default.createElement(_SimilarTrips2.default, { trip: trip })
          )
        ),
        !peerReview && _react3.default.createElement(
          'div',
          { styleName: 'inner-customize' },
          _react3.default.createElement(_CustomizeBox2.default, null)
        ),
        !(user && user._id === trip.user_id._id) && _react3.default.createElement(
          'div',
          { styleName: 'mobile-only' },
          _react3.default.createElement(_MobileAction2.default, { trip: trip, peerReview: peerReview })
        ),
        peerReview && _react3.default.createElement(
          _Modal2.default,
          { isOpen: isOpenPeerReview, centerVertical: true, onClose: this.onClosePeerReview, id: 'peerReview' },
          _react3.default.createElement(_PeerReviewForm2.default, null)
        ),
        _react3.default.createElement(
          _Modal2.default,
          { isOpen: isOpenChat, onClose: this.closeChat, centerVertical: true, style: { 'maxWidth': '600px', 'padding': '0', 'margin': '0 auto' }, noClose: true, id: 'trip-chat' },
          _react3.default.createElement(_Chat2.default, { trip: trip })
        )
      );
    }
  }]);
  return Main;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object,
  sessionData: _react2.PropTypes.object,
  isOpenChat: _react2.PropTypes.bool,
  peerReview: _react2.PropTypes.bool,
  openChat: _react2.PropTypes.func,
  openPeerReview: _react2.PropTypes.func,
  user: _react2.PropTypes.object,
  logCustomizeTrip: _react2.PropTypes.func,
  requestBooking: _react2.PropTypes.func,
  locale: _react2.PropTypes.string,
  tab: _react2.PropTypes.string,
  isOpenPeerReview: _react2.PropTypes.bool,
  //
  weChatEveryLink: _react2.PropTypes.bool
}, _temp)) || _class) || _class));

exports.default = Main;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/Main.js
// module id = 1635
// module chunks = 0